import type { ThemeInstance } from 'vuetify';
import CLocal from '@/services/storage/CLocal';
import ETemaAplicacao from '@/shared/enums/ETemaAplicacao';

export default class ThemeUtils {
  static inicializar(pInstaceTheme: ThemeInstance) {
    const tema = ETemaAplicacao.Claro; //CLocal.tema; Gualter: Desabilitado

    ThemeUtils.definir(tema, pInstaceTheme);
  }

  static definir(pTema: ETemaAplicacao, pInstaceTheme: ThemeInstance) {
    if (!pTema || !Object.values(ETemaAplicacao).includes(pTema)) {
      console.error(`O tema recebido: "${pTema}" é inválido ou não está na lista de temas pré-definidos!`);
    }

    switch (pTema) {
      case ETemaAplicacao.Claro:
        pInstaceTheme.change('LightTheme');
        break;
      case ETemaAplicacao.Escuro:
        pInstaceTheme.change('DarkTheme');
        break;
      default: {
        pTema = ETemaAplicacao.Escuro;
        pInstaceTheme.change('DarkTheme');
        console.error(`A aplicação não foi preparada para lidar com o tema: ${pTema}`);
      }
    }

    CLocal.tema = pTema;
  }

  static obter(pInstaceTheme: ThemeInstance): ETemaAplicacao {
    try {
      if (pInstaceTheme.global.name.value == 'LightTheme') return ETemaAplicacao.Claro;
      if (pInstaceTheme.global.name.value == 'DarkTheme') return ETemaAplicacao.Escuro;
      throw `O tema: [${pInstaceTheme.global.name.value}] naõ foi mapeado adequadamente em "ThemeUtils.obter"`;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
